export const getPageNumberFromUrl = () => +window.location.hash.replace(/[^\d]/g, '');
